import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

/**
 * Moves focus to `<main>` on every navigation (doc 09, M14 › a11y).
 *
 * In a single-page app a link click leaves focus on an element that may no longer exist,
 * so a screen-reader or keyboard user is told nothing about arriving somewhere new and
 * has to tab from the top of the page again. Focusing `<main>` announces the new screen
 * and puts the next Tab inside it.
 *
 * The first render is skipped: taking focus on load would interrupt someone who is
 * already reading, and there's nowhere to have come from.
 */
export function RouteFocus() {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    const main = document.getElementById('main');
    // `preventScroll`, because the app manages scroll position itself.
    main?.focus({ preventScroll: true });
    window.scrollTo({ top: 0 });
  }, [pathname]);

  return null;
}
